import { all_routes } from "../feature-module/router/all_routes";

export const MIME_TYPE_MAP: Record<string, string> = {
    mp4: 'video/mp4',
    webp: 'image/webp',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    avi: 'video/x-msvideo',
    mov: 'video/quicktime',
};

export const DEVICE_TYPE = 'web';

// export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
export const phoneRegExp = /^(\+?\d{10,14})$/;
/** US phone: 9–10 digits (prefix +1 is fixed in signup) */
export const phoneUSDigitsOnly = /^\d{9,10}$/;
export const PHONE_COUNTRY_CODE = "+1";

// export const nameRegex = /^[A-Za-z][A-Za-z\s]{0,49}[A-Za-z]$/;

export const nameRegex = /^[a-zA-Zà-ÿÀ-Ÿ'’\-\. ]{1,100}$/;

// export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

// export const emailRegex =  /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+(?:com|org|net|edu|gov|info|io|co|in|uk|us|ca|biz|me|tech|dev|ai)$/;

//======= global standard (RFC 5322 / RFC 5321)  ========//
export const emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@(?:[a-zA-Z0-9-]+\.)+(com|org|net|edu|gov|info|io|co|in|uk|us|ca|biz|me|tech|dev|ai)$/i;

export type DeleteModalType = "" | "deleteAccount" | "archiveUser" | "deleteProperty" | "deleteInvitedUser" | "archiveProperty" | "archiveLogHour" | "deleteMileageReceipt" | "deleteLogHourReceipt" | "deleteMileage" | "spouceDeleteLogHour" | "archiveActivity" | "archiveNonRealLogHour" | "deleteNonRealLogHourDocument" | "activeUser" | "inactiveUser" | "cancelSubscription" | "deleteCard" | "setDefaultCard";

export type UploadCsvModalType = "" | "uploadLogHourCsv";

export type AcceptRequestModalType = "" | "acceptRequestByOwner";

export const recurringDays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
];

export const logHourStatusOptions = [
    { label: "Select Status", value: "" },
    { label: "Accepted", value: "accept" },
    { label: "Rejected", value: "reject" },
]

export const auditTrailActionOptions = [
    { label: "All", value: "all" },
    { label: "Created property", value: "created property" },
    { label: "Modified property", value: "modified property" },
    { label: "Deleted property", value: "deleted property" },
    { label: "Created time entry", value: "created time entry" },
    { label: "Modified time entry", value: "modified time entry" },
    { label: "Deleted time entry", value: "deleted time entry" },
    { label: "Created mileage entry", value: "created mileage entry" },
    // { label: "Modified mileage entry", value: "modified mileage entry" },
    { label: "Deleted mileage entry", value: "deleted mileage entry" },
]

export const auditTrailRoleOptions = [
    { label: "Real Estate Professional", value: "real_estate_professional" },
    { label: "Spouse", value: "spouse" },
    { label: "Both", value: "both" },
]

export const supportIssueCategoryOptions = [
    { label: "Select an issue", value: "" },
    { label: "Login Issue", value: "login_issue" },
    { label: "Payment / Billing", value: "payment_billing" },
    { label: "Subscription", value: "subscription" },
    { label: "Technical Problem", value: "technical_problem" },
    { label: "Feature Request", value: "feature_request" },
    { label: "Other", value: "other" },
]


const routes: any = all_routes;
export const hideHeaderToggleRoutes = [
    routes.pricing,
    routes.paymentSuccess,
    routes.PaymentFailed,
]

export const hideHeaderProfileRoutes = [
    routes.pricing,
    routes.paymentSuccess,
    routes.PaymentFailed,
]

export const hideAuthHeaderLoginRoutes = [
    routes.pricing,
    routes.paymentSuccess,
    routes.PaymentFailed,
    routes.successMessage,
    routes.forgotPasssword,
    routes.confirmEmail,
    routes.resetPassword,
    routes.verificationOtp,
    routes.thankYou,
]

export const hideHeaderSidebarToggleRoutes = [
    routes.contactUs,
    routes.termsCondition,
    routes.privacyPolicy,
    routes.faq,
    routes.aboutUs,
    routes.blog,
    routes.blogDetails,
    routes.cmsPricing,
    routes.pricing,
    routes.paymentSuccess,
    routes.PaymentFailed,
]